import React, { useContext, useEffect, useState } from 'react'
import Button from '@material-ui/core/Button'
import DoneIcon from '@material-ui/icons/Done'
import { ClassNameMap } from '@material-ui/core/styles/withStyles'
import { getButtonIcon } from '../OnScreenInfo/InformationContent'
import DynamicFormContext from './provider/DynamicFormContext'
import { useTranslation } from 'react-i18next'

interface SubmitFormButtonProps {
  muiClasses: ClassNameMap
  size?: 'large' | 'medium' | 'small'
  color?: 'default' | 'inherit' | 'primary' | 'secondary'
  alternateCard?: boolean
  startIcon?:
    | 'Delete'
    | 'Add'
    | 'Done'
    | 'ArrowForward'
    | 'ArrowBack'
    | 'Play'
    | 'Done'
    | 'CircularProgress'
  endIcon?:
    | 'Delete'
    | 'Add'
    | 'Done'
    | 'ArrowForward'
    | 'ArrowBack'
    | 'Play'
    | 'Done'
    | 'CircularProgress'
  variant?: 'contained' | 'outlined' | 'text'
  additionalData: any
  autoSubmit?: boolean
}

const SubmitFormButton: React.FC<SubmitFormButtonProps> = ({
  muiClasses,
  size,
  color,
  alternateCard,
  startIcon,
  endIcon,
  variant,
  additionalData,
  autoSubmit = true
}) => {
  const {
    submitForm,
    formSubmitSuccess,
    formSubmitted,
    setFormSubmitted
  } = useContext(DynamicFormContext)

  const { t } = useTranslation()
  const [firstSubmit, setFirstSubmit] = useState(true)

  const submit = () => {
    if (!formSubmitted) {
      setFirstSubmit(false)
      setFormSubmitted(true)
      console.log('Triggering form submission')
      submitForm(additionalData)
    }
  }

  useEffect(() => {
    if (autoSubmit) {
      submit()
    }

    /* clean up send timeout handler when component unmounts */
    return () => {}
  }, [formSubmitSuccess, formSubmitted])

  return (
    <DynamicFormContext.Consumer>
      {context => (
        <React.Fragment>
          {formSubmitted && formSubmitSuccess ? (
            <h2>
              {t('DynamicForms.sendSuccessful')} <DoneIcon fontSize="large" />
            </h2>
          ) : (
            <React.Fragment>
              <Button
                className={muiClasses.utteranceButton}
                key="submit"
                style={{ justifyContent: 'flex-start', marginTop: '20px' }}
                disabled={formSubmitted && !formSubmitSuccess}
                size={size || 'large'}
                color={color || alternateCard ? 'inherit' : 'primary'}
                variant={variant ? variant : 'contained'}
                startIcon={startIcon ? getButtonIcon(startIcon) : ''}
                endIcon={
                  formSubmitSuccess
                    ? getButtonIcon('Done')
                    : formSubmitted
                    ? getButtonIcon('CircularProgress')
                    : getButtonIcon('ArrowForward')
                    ? endIcon
                      ? getButtonIcon(endIcon)
                      : ''
                    : ''
                }
                onClick={event => {
                  event.preventDefault()
                  submit()
                }}
              >
                {!formSubmitted && !formSubmitSuccess
                  ? firstSubmit
                    ? t('DynamicForms.submit')
                    : t('DynamicForms.retry')
                  : ''}
                {formSubmitted && !formSubmitSuccess
                  ? t('DynamicForms.sending')
                  : ''}
                &nbsp;
              </Button>
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </DynamicFormContext.Consumer>
  )
}

export default SubmitFormButton
